import PaymentReceivedModal from './PaymentReceivedModal'

const PaymentReceivedWithCoupon = () => <PaymentReceivedModal bodyText='The coupon was successfully applied.' />

export default PaymentReceivedWithCoupon
